// extracted by css-extract-rspack-plugin
export default {"rings":"AJeV0mbda6ItRO41","ring":"LQ99lbuYd0S6QqJp","badge":"jRjQqCdQp6I3xjkL","isSmall":"O3uwOPV2VgwId_Ah"};